import { CartLinesUpdateEvent, StandardEvents } from '@shopify/events';

// Keep the announcement marquee's free-shipping message in sync with the cart.
function updateFreeShippingMarquee(totalPence) {
  const spans = document.querySelectorAll('[data-lupa-free-marquee]');
  if (!spans.length) return;
  const threshold = parseInt(spans[0].getAttribute('data-threshold'), 10);
  if (!threshold) return;

  let msg;
  if (!totalPence) {
    msg = 'Free UK delivery over £' + (threshold / 100).toFixed(2).replace(/\.00$/, '');
  } else if (totalPence < threshold) {
    msg = "You're £" + ((threshold - totalPence) / 100).toFixed(2) + ' away from free UK delivery';
  } else {
    msg = "You've unlocked free UK delivery";
  }
  spans.forEach((s) => { s.textContent = msg; });
}

document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  event.promise
    ?.then(() => fetch('/cart.js').then((r) => r.json()))
    .then((cart) => updateFreeShippingMarquee(cart.total_price))
    .catch(() => {});
});

// Delegated so the listener survives drawer morphs.
document.addEventListener('click', async (event) => {
  const btn = event.target instanceof Element && event.target.closest('[data-lupa-upsell-add]');
  if (!btn || btn.disabled || btn.classList.contains('is-loading')) return;

  const variantId = btn.dataset.variantId;
  if (!variantId) return;

  btn.classList.add('is-loading');

  try {
    const addRes = await fetch(window.Theme?.routes?.cart_add_url || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }],
        sections: 'cart-drawer-section',
      }),
    });
    const added = await addRes.json();
    if (!addRes.ok || added.status) throw new Error(added.message || 'Add to cart failed');

    const ajaxCart = await fetch('/cart.js').then((r) => r.json());

    const deferred = CartLinesUpdateEvent.createPromise();
    document.dispatchEvent(
      new CartLinesUpdateEvent({
        action: 'add',
        context: 'cart-upsell',
        lines: [{ merchandiseId: variantId, quantity: 1 }],
        promise: deferred.promise,
      })
    );
    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart),
      detail: {
        items: ajaxCart.items,
        sections: added.sections || undefined,
        source: 'lupa-cart-upsell',
        itemCount: 1,
      },
    });
  } catch (error) {
    console.warn('[lupa-cart-upsell]', error);
    btn.classList.remove('is-loading');
  }
});
